<template>
  <configuration-container :options="options"></configuration-container>
</template>

<script>
import ConfigurationContainer from '@/components/admin/ConfigurationContainer.vue'

export default {
  components: {
    ConfigurationContainer,
  },
  data() {
    return {
      options: [{
        name: 'Plant',
        level: 0,
        maxLevel: 1,
        component: 'PlantList'
      },
      {
        name: 'User',
        level: 0,
        maxLevel: 1,
        component: 'UserList'
      },
      {
        name: 'Global',
        level: 1,
        maxLevel: 1,
        component: 'GlobalConfig'
      }]
    }
  },
}
</script>

<style></style>
